import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TMasterKubunPutReq } from "./TKubun"

export const kubunRegisterPostScheme: JSONSchemaType<TMasterKubunPutReq> = {
  type: "object",
  properties: {
    区分ID: {
      type: "number",
      nullable: true,
      title: "区分ID",
      maximum: 1,
    },
    区分コード: {
      type: "string",
      nullable: true,
      title: "区分コード",
      pattern: validateConstant.PATTERN.数字のみ,
      minLength: 1,
      maxLength: validateConstant.LENGTH.汎用区分コード,
      // errorMessage: util.stringErrorMessage("区分コード", {
      //   required: true,
      // }),
    },
    名称1: {
      type: "string",
      nullable: true,
      title: "名称1",
      maxLength: validateConstant.LENGTH.一般名称,
      errorMessage: util.stringErrorMessage("名称1", {
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    名称2: {
      type: "string",
      nullable: true,
      title: "名称2",
      maxLength: validateConstant.LENGTH.一般名称,
      errorMessage: util.stringErrorMessage("名称2", {
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    名称3: {
      type: "string",
      nullable: true,
      title: "名称3",
      maxLength: validateConstant.LENGTH.一般名称,
      errorMessage: util.stringErrorMessage("名称3", {
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    数値1: {
      type: "number",
      nullable: true,
      title: "数値1",
      minimum: 0,
      maximum: 2147483647,
      errorMessage: util.stringErrorMessage("数値1"),
    },
    数値2: {
      type: "number",
      nullable: true,
      minimum: 0,
      maximum: 2147483647,
      title: "数値2",
      errorMessage: util.stringErrorMessage("数値2"),
    },
    数値3: {
      type: "number",
      nullable: true,
      minimum: 0,
      maximum: 2147483647,
      title: "数値3",
      errorMessage: util.stringErrorMessage("数値3"),
    },
    小数値1: {
      type: "number",
      nullable: true,
      minimum: 0,
      title: "小数値1",
      errorMessage: util.stringErrorMessage("小数値1"),
    },
    小数値2: {
      type: "number",
      nullable: true,
      minimum: 0,
      title: "小数値2",
      errorMessage: util.stringErrorMessage("小数値"),
    },
    小数値3: {
      type: "number",
      nullable: true,
      minimum: 0,
      title: "小数値3",
      errorMessage: util.stringErrorMessage("小数値3"),
    },
    ソート番号: {
      type: "number",
      title: "ソート番号",
      nullable: true,
      errorMessage: util.stringErrorMessage("ソート番号", {
        required: true,
      }),
    },
    備考: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般テキスト,
      title: "備考",
      nullable: true,
      errorMessage: util.stringErrorMessage("備考", {
        required: false,
        maxLength: validateConstant.LENGTH.一般テキスト,
      }),
    },
    変更可能フラグ: {
      type: "number",
      nullable: true,
      title: "変更可能フラグ",
    },
    削除フラグ: {
      type: "number",
      nullable: true,
      title: "削除フラグ",
    },
    更新日時: {
      type: "string",
      nullable: true,
      title: "更新日時",
    },
    更新ユーザID: {
      type: "number",
      nullable: true,
      title: "更新ユーザID",
    },
  },
  required: [],
  errorMessage: {
    required: util.JsonSchemeRequiredErrorMessages([]),
  },
}
